import GlobalNotification from '@/components/global-notification/CreateGlobalNotification';

export default function NewNotifications() {
	return (
		<div className="flex items-center h-full pt-10 flex-col">
			<GlobalNotification />
		</div>
	);
}
